(function () {
	function setRem() {
		const baseSize = 100;
		const scale = document.documentElement.clientWidth / 3840;
		document.documentElement.style.fontSize = baseSize * scale + 'px';
	}

// 监听窗口变化
	window.addEventListener('resize', setRem);

// 页面加载时执行
	setRem();
})()
